import BlockContent from '@sanity/block-content-to-react'
import React, { useMemo } from 'react'

import { SanityBannerWithBodyAndImages } from '../../../graphql/gatsby'
import { getGatsbyImageDataForAsset } from '../../../utils/sanity/image'
import { serializers } from './serializers'
import * as Styled from './styled'

export type BannerWithBodyAndImagesProps = SanityBannerWithBodyAndImages

const BannerWithBodyAndImages: React.FC<BannerWithBodyAndImagesProps> = ({
  title,
  images,
  body,
}) => {
  const gatsbyImages = useMemo(() => {
    return images?.map((image) => {
      return getGatsbyImageDataForAsset(image, {
        width: 720,
        fit: 'scale',
      })
    })
  }, [images])

  return (
    <Styled.Container>
      <div>{title && <Styled.Title>{title}</Styled.Title>}</div>
      <div>
        <Styled.BodyContainer>
          {body && <BlockContent blocks={body} serializers={serializers} />}
        </Styled.BodyContainer>
        <Styled.ImagesContainer>
          {!!gatsbyImages &&
            gatsbyImages.map(
              (image, index) => !!image && <Styled.Image key={index} image={image} alt="" />,
            )}
        </Styled.ImagesContainer>
      </div>
    </Styled.Container>
  )
}

export default BannerWithBodyAndImages
